import React from 'react'

import {
  Typography,
  type TypographyProps,
} from '~/components/elements/Typography'

import styles from './LabelingContainer.css'

export type LabelingContainerProps = {
  children?: React.ReactNode
  className?: string
  'data-testid'?: string
  label: React.ReactNode
  labelVariant?: TypographyProps['variant']
}

export const LabelingContainer = ({
  children,
  className,
  'data-testid': dataTestId = 'components-elements-labeling-container',
  label,
  labelVariant = 'normal',
}: LabelingContainerProps) => (
  <div className={className} data-testid={dataTestId}>
    <Typography variant={labelVariant}>{label}</Typography>

    <div className={styles.childrenContainer}>{children}</div>
  </div>
)
